import { MoreVertRounded } from '@mui/icons-material';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Popper,
} from '@mui/material';
import { MouseEvent, ReactNode, useState } from 'react';

interface MoreChartActionsButtonProps {
  isMenuItem?: boolean;
  children: ReactNode;
}

export const MoreChartActionsButton = ({
  isMenuItem = false,
  children,
}: MoreChartActionsButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const openPopper = (e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget ?? e.target);
  };

  const closePopper = () => {
    setAnchorEl(null);
  };

  const isMenuOpen = Boolean(anchorEl);

  const renderPopper = () => {
    return (
      <Popper
        open={isMenuOpen}
        anchorEl={anchorEl}
        placement="right-start"
        sx={{
          zIndex: 3001,
        }}
        modifiers={[
          {
            name: 'flip',
            enabled: true,
            options: {
              fallbackPlacements: ['left-start'],
            },
          },
        ]}
      >
        <Paper
          elevation={8}
          sx={{
            borderRadius: 2,
          }}
        >
          {children}
        </Paper>
      </Popper>
    );
  };

  if (isMenuItem) {
    return (
      <Box onMouseEnter={openPopper} onMouseLeave={closePopper}>
        {renderPopper()}
        <MenuItem>
          <ListItemIcon>
            <MoreVertRounded
              sx={{
                color: 'text.disabled',
              }}
            />
          </ListItemIcon>
          <ListItemText primary="More" />
        </MenuItem>
      </Box>
    );
  }

  return (
    <Box onMouseEnter={openPopper} onMouseLeave={closePopper}>
      {renderPopper()}
      <ListItem dense disablePadding>
        <ListItemButton>
          <ListItemIcon>
            <MoreVertRounded
              sx={{
                color: 'text.disabled',
              }}
            />
          </ListItemIcon>
          <ListItemText primary="More" />
        </ListItemButton>
      </ListItem>
    </Box>
  );
};
